import { svg_include } from "base/functions";
import WebsiteModal from "webPage/modal/WebsiteModal";

export default class FiltersModal extends WebsiteModal {

    constructor($form) {
        super();
        this.$form = $form.clone();
    }


    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {type: "button", className: "modal__close-btn js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__header"}, [
                        eotwJSXFactory('span', {className: "modal__icon", unsafeHtml: svg_include('filter-icon')}),
                        eotwJSXFactory('span', {className: "modal__title"}, ["Customer Filters"])
                    ]),
                    eotwJSXFactory('form', {action: ""}, [
                        eotwJSXFactory('div', {className: "modal__content"}, [
                            this.$form
                        ]),
                        eotwJSXFactory('div', {className: "modal__action-wrap"}, [
                            eotwJSXFactory('button', {type: "submit", className: "btn btn--mobile-full btn--rounded"}, ["Update results"])
                        ])
                    ])
                ])
            ])
        );
    }
}
